export default "__VITE_ASSET__tdtzOFMr__"